// Custom JavaScript for Judgeme

document.addEventListener("DOMContentLoaded", function () {
  // Récupérer les valeurs de data-score et data-number-of-reviews
  function getJudgeMeReviewStats() {
    const ratingElement = document.querySelector(".jdgm-all-reviews-rating");
    const reviewsCountElement = document.querySelector(
      ".jdgm-carousel-number-of-reviews",
    );

    if (!ratingElement || !reviewsCountElement) {
      // Si les éléments ne sont pas encore chargés, réessayer après un délai
      setTimeout(getJudgeMeReviewStats, 500);
      return;
    }

    const rating = ratingElement.getAttribute("data-score");
    const reviewsCount = reviewsCountElement.getAttribute(
      "data-number-of-reviews",
    );

    console.log("Rating:", rating);
    console.log("Reviews Count:", reviewsCount);

    // Créer la section d'affichage des statistiques
    createReviewStatsSection(rating, reviewsCount);
  }

  // Créer la section d'affichage des statistiques
  function createReviewStatsSection(rating, reviewsCount) {
    const reviewsSection = document.getElementById(
      "shopify-section-template--25090203615580__174481053732571b55",
    );

    if (!reviewsSection) {
      setTimeout(() => createReviewStatsSection(rating, reviewsCount), 500);
      return;
    }

    // Vérifier si la section existe déjà
    if (document.querySelector(".affichage_reviews_all_judgemecustom")) {
      return;
    }

    // Créer la nouvelle section
    const statsSection = document.createElement("section");
    statsSection.className = "affichage_reviews_all_judgemecustom";
    statsSection.textContent = `(  ${reviewsCount} REVIEWS ${rating}/5)`;

    // Insérer avant la section des avis
    reviewsSection.parentNode.insertBefore(statsSection, reviewsSection);
  }

  // Fonction pour réorganiser les avis JudgeMe
  function reorganizeJudgeMeReviews() {
    // Sélectionner tous les éléments d'avis
    const reviewItems = document.querySelectorAll(".jdgm-carousel-item");

    if (reviewItems.length === 0) {
      // Si les éléments ne sont pas encore chargés, réessayer après un délai
      setTimeout(reorganizeJudgeMeReviews, 500);
      return;
    }

    reviewItems.forEach(function (item) {
      // Récupérer les éléments originaux
      const title = item.querySelector(".jdgm-carousel-item__review-title");
      const body = item.querySelector(".jdgm-carousel-item__review-body");
      const name = item.querySelector(".jdgm-carousel-item__reviewer-name");
      const date = item.querySelector(".jdgm-carousel-item__timestamp");
      const stars = item.querySelector(".jdgm-carousel-item__review-rating");
      const reviewContainer = item.querySelector(".jdgm-carousel-item__review");

      if (!title || !body || !name || !date || !stars || !reviewContainer)
        return;

      // Vider le contenu du conteneur d'avis
      reviewContainer.innerHTML = "";

      // 1. Ajouter le titre en premier
      reviewContainer.appendChild(title);

      // 2. Créer un div pour le nom et le commentaire
      const commentDiv = document.createElement("div");
      commentDiv.className = "judgeme_custom_commentaire";

      // Créer le span pour le nom
      const nameSpan = document.createElement("span");
      nameSpan.className = "judgeme_custom_name";
      nameSpan.textContent = name.textContent.trim();

      // Ajouter le span du nom au div de commentaire
      commentDiv.appendChild(nameSpan);

      // Ajouter le séparateur
      commentDiv.appendChild(document.createTextNode(" — "));

      // Créer le span pour le commentaire
      const commentSpan = document.createElement("span");
      commentSpan.className = "judgeme_custom_commentaire_content";
      commentSpan.textContent = body.textContent.trim();

      // Ajouter le span du commentaire au div de commentaire
      commentDiv.appendChild(commentSpan);

      // Ajouter le div de commentaire au conteneur d'avis
      reviewContainer.appendChild(commentDiv);

      // 3. Créer un div pour les étoiles et la date
      const starsDateDiv = document.createElement("div");
      starsDateDiv.className = "judgeme_custom_stars_and_date";

      // Créer le span pour les étoiles
      const starsSpan = document.createElement("span");
      starsSpan.className = "judgeme_custom_stars";
      starsSpan.innerHTML = stars.innerHTML;

      // Ajouter le span des étoiles au div des étoiles et de la date
      starsDateDiv.appendChild(starsSpan);

      // Créer le span pour la date
      const dateSpan = document.createElement("span");
      dateSpan.className = "judgeme_custom_date";

      // Calculer le nombre de jours écoulés
      const reviewDate = new Date(date.textContent.trim());
      const today = new Date();
      const diffTime = Math.abs(today - reviewDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // Afficher "IL Y A X JOURS"
      dateSpan.textContent = `(IL Y A ${diffDays} JOURS)`;

      // Ajouter le span de la date au div des étoiles et de la date
      starsDateDiv.appendChild(dateSpan);

      // Ajouter le div des étoiles et de la date au conteneur d'avis
      reviewContainer.appendChild(starsDateDiv);
    });
  }

  // Fonction pour ajouter une barre de progression
  function addProgressBar() {
    // Vérifier si la barre de progression existe déjà
    if (document.querySelector(".judgeme_custom_progress_bar_container")) {
      return; // Ne pas ajouter de barre de progression si elle existe déjà
    }

    const carouselSection = document.querySelector(".jdgm-carousel");
    if (!carouselSection) return;

    // Créer le conteneur de la barre de progression
    const progressBarContainer = document.createElement("div");
    progressBarContainer.className = "judgeme_custom_progress_bar_container";

    // Créer la barre de progression
    const progressBar = document.createElement("div");
    progressBar.className = "judgeme_custom_progress_bar";

    // Ajouter la barre de progression au conteneur
    progressBarContainer.appendChild(progressBar);

    // Insérer le conteneur juste avant la fermeture de la section
    carouselSection.appendChild(progressBarContainer);

    // Configurer la mise à jour de la barre de progression lors du défilement du carrousel
    const itemWrapper = document.querySelector(".jdgm-carousel__item-wrapper");
    const totalItems = document.querySelectorAll(".jdgm-carousel-item").length;

    // Observer les changements de style (transform) sur itemWrapper
    const itemWrapperObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "style") {
          updateProgressBar();
        }
      });
    });

    if (itemWrapper) {
      itemWrapperObserver.observe(itemWrapper, {
        attributes: true,
        attributeFilter: ["style"],
      });

      // Fonction pour mettre à jour la barre de progression
      function updateProgressBar() {
        const transform = itemWrapper.style.transform;
        if (!transform) return;

        // Extraire la valeur de translate3d
        const match = transform.match(/translate3d\((-?\d+)px/);
        if (!match) return;

        const translateX = parseInt(match[1], 10);
        const itemWidth = itemWrapper.firstElementChild.offsetWidth;
        const totalWidth = itemWidth * totalItems;

        // Calculer la progression (inversée car translate3d est négatif)
        const progress = Math.min(
          1,
          Math.max(0, Math.abs(translateX) / (totalWidth - itemWidth * 2)),
        );

        // Mettre à jour la largeur de la barre de progression
        progressBar.style.width = progress * 100 + "%";
      }

      // Initialiser la barre de progression
      updateProgressBar();
    }
  }

  // Fonction pour ajouter la navigation par glissement (swipe)
  function addSwipeNavigation() {
    const carousel = document.querySelector(".jdgm-carousel");
    if (!carousel) return;

    let startX, startY;
    let isDragging = false;
    let startTranslateX = 0;
    let currentTranslateX = 0;
    const itemWrapper = document.querySelector(".jdgm-carousel__item-wrapper");

    // Fonction pour obtenir la valeur actuelle de translate3d
    function getCurrentTranslate() {
      const transform = itemWrapper.style.transform;
      const match = transform.match(/translate3d\((-?\d+)px/);
      return match ? parseInt(match[1], 10) : 0;
    }

    // Gestionnaire d'événements pour le début du toucher/clic
    function handleStart(e) {
      const touchEvent = e.touches ? e.touches[0] : e;
      startX = touchEvent.clientX;
      startY = touchEvent.clientY;
      isDragging = true;
      startTranslateX = getCurrentTranslate();

      // Désactiver la transition pendant le glissement
      itemWrapper.style.transition = "none";
    }

    // Gestionnaire d'événements pour le mouvement du toucher/clic
    function handleMove(e) {
      if (!isDragging) return;

      const touchEvent = e.touches ? e.touches[0] : e;
      const deltaX = touchEvent.clientX - startX;

      // Limiter le déplacement pour éviter de sortir des limites
      currentTranslateX = startTranslateX + deltaX;

      // Appliquer le déplacement
      itemWrapper.style.transform = `translate3d(${currentTranslateX}px, 0px, 0px)`;

      // Mettre à jour la barre de progression
      updateProgressBarByPosition(currentTranslateX);

      // Empêcher le défilement de la page
      // e.preventDefault();
    }

    // Gestionnaire d'événements pour la fin du toucher/clic
    function handleEnd() {
      if (!isDragging) return;
      isDragging = false;

      // Réactiver la transition
      itemWrapper.style.transition = "";

      // Calculer l'élément le plus proche pour un "snap" fluide
      const itemWidth = itemWrapper.firstElementChild.offsetWidth;
      const snapPosition =
        Math.round(currentTranslateX / itemWidth) * itemWidth;

      // Limiter la position pour éviter de sortir des limites
      const totalItems = document.querySelectorAll(
        ".jdgm-carousel-item",
      ).length;
      const minTranslate = -itemWidth * (totalItems - 1);
      const maxTranslate = 0;

      const limitedPosition = Math.min(
        maxTranslate,
        Math.max(minTranslate, snapPosition),
      );

      // Appliquer la position finale
      itemWrapper.style.transform = `translate3d(${limitedPosition}px, 0px, 0px)`;

      // Mettre à jour la barre de progression
      updateProgressBarByPosition(limitedPosition);
    }

    // Fonction pour mettre à jour la barre de progression en fonction de la position
    function updateProgressBarByPosition(position) {
      const progressBar = document.querySelector(
        ".judgeme_custom_progress_bar",
      );
      if (!progressBar) return;

      const itemWidth = itemWrapper.firstElementChild.offsetWidth;
      const totalItems = document.querySelectorAll(
        ".jdgm-carousel-item",
      ).length;
      const totalWidth = itemWidth * totalItems;

      // Calculer la progression (inversée car translate3d est négatif)
      const progress = Math.min(
        1,
        Math.max(0, Math.abs(position) / (totalWidth - itemWidth * 2)),
      );

      // Mettre à jour la largeur de la barre de progression
      progressBar.style.width = progress * 100 + "%";
    }



    if (window.matchMedia('(pointer: fine)').matches) {
      // Ajouter les écouteurs d'événements pour le toucher
      carousel.addEventListener("touchstart", handleStart, { passive: true });
      carousel.addEventListener("touchmove", handleMove, { passive: true });
      carousel.addEventListener("touchend", handleEnd);

      // Ajouter les écouteurs d'événements pour la souris
      carousel.addEventListener("mousedown", handleStart);
      document.addEventListener("mousemove", handleMove);
      document.addEventListener("mouseup", handleEnd);
    }
  }

  // Observer les mutations du DOM pour détecter quand JudgeMe charge ses avis
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (document.querySelector(".jdgm-carousel--done")) {
        reorganizeJudgeMeReviews();
        addProgressBar();
        addSwipeNavigation();
        observer.disconnect();
      }
    });
  });

  // Démarrer l'observation du DOM
  observer.observe(document.body, { childList: true, subtree: true });

  // Essayer de réorganiser immédiatement au cas où les avis sont déjà chargés
  reorganizeJudgeMeReviews();

  // Initialiser les fonctions
  getJudgeMeReviewStats();
});

// Script pour transformer le texte des badges d'avis JudgeMe
// Transforme "X avis" en "REVIEWS ( X )"
document.addEventListener("DOMContentLoaded", function () {
  // Fonction pour transformer le texte des badges
  function transformReviewBadges() {
    const badges = document.querySelectorAll(".jdgm-prev-badge__text");

    badges.forEach(function (badge) {
      // Récupérer le texte actuel (par exemple "3 avis")
      const currentText = badge.textContent.trim();

      // Extraire le nombre d'avis
      const match = currentText.match(/(\d+)/);

      if (match && match[1]) {
        // Créer le nouveau format "REVIEWS ( X )"
        const reviewCount = match[1];
        badge.textContent = `REVIEWS ( ${reviewCount} )`;
      }
    });
  }

  // Attendre que JudgeMe soit chargé (délai de 2 secondes)
  setTimeout(transformReviewBadges, 2000);

  // Essayer à nouveau après 4 secondes pour s'assurer que tous les badges sont transformés
  setTimeout(transformReviewBadges, 4000);
});
